module.exports = __webpack_public_path__ + "static/media/grupo-estudo.c012c24e.md";